(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/components/hero.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/components/hero.js');

'use strict';

const {
  MultiImage
} = svs.content.image_v2;
const {
  Topwins,
  HeroText,
  CloseTimeCountdown
} = svs.gamePackage.components;
const Hero = _ref => {
  let {
    images,
    textColor,
    heroContentList = []
  } = _ref;
  const HeroContent = _ref2 => {
    let {
      content
    } = _ref2;
    if (!content) {
      return;
    }
    return content.map((item, i) => {
      switch (true) {
        case item.isTopWins:
          return React.createElement(Topwins, {
            key: i
          });
        case item.isClosetimeCountdown:
          return React.createElement(CloseTimeCountdown, {
            key: i,
            useDarkBg: textColor === 'fc-white'
          });
        case item.isText:
          return React.createElement(HeroText, {
            key: i,
            title: item.title,
            body: item.body
          });
        default:
      }
    });
  };
  if (images) {
    return React.createElement("div", {
      className: "gp-hero-wrapper"
    }, React.createElement(MultiImage, {
      altText: "",
      cssSelectors: "gp-hero-multi-image",
      images: images,
      fitWrapper: true,
      title: ""
    }), React.createElement("div", {
      className: "gp-hero-content ".concat(textColor)
    }, React.createElement(HeroContent, {
      content: heroContentList
    })));
  }
  return null;
};
svs.gamePackage.components.Hero = Hero;

 })(window);